@if (enabled() && options().length) {
    <app-multi-select-input
        [form]="form()"
        [id]="id()"
        [label]="label()"
        [staticOptions]="options()"
        [group]="hasGroups()"
        valueKey="id"
        labelKey="label"
        filterBy="label"
        [showClear]="true"
    >
        <ng-template #item let-item>
            {{ item | formatPerson }}
        </ng-template>
        <ng-template #selectedItems let-items>
            @if ((items?.length || 0) > 2) {
                <div>{{ 'common.selectedItems' | translate:{ count: items.length } }}</div>
            } @else {
                <div class="flex gap-small">
                    @for (item of items; track item.id) {
                        <app-user-chip
                            [user]="item"
                            [renderType]="UserChipRenderTypeEnum.Client"
                            [renderDetails]="false"
                        ></app-user-chip>
                    }
                </div>
            }
        </ng-template>
    </app-multi-select-input>
}
